function isEmptyRow(row) {
  return row.every((value) => value === null || value === undefined)
}

function createHeaderKeys(rows, headerRowIndex) {
  const columnCount = rows.reduce(
    (max, row) => Math.max(max, row.length),
    0
  )
  const headerRow = rows[headerRowIndex] || []
  const usedKeys = new Set()

  return Array.from({ length: columnCount }, (_, columnIndex) => {
    const header = headerRow[columnIndex]
    const baseKey =
      header === null || header === undefined ? '__EMPTY' : String(header)
    let key = baseKey
    let suffix = 1

    while (usedKeys.has(key)) {
      key = `${baseKey}_${suffix}`
      suffix += 1
    }

    usedKeys.add(key)
    return key
  })
}

export function spreadsheetRowsToObjects(rows, { headerRowIndex = 0 } = {}) {
  if (!Array.isArray(rows) || rows.length <= headerRowIndex) return []

  const headerKeys = createHeaderKeys(rows, headerRowIndex)

  return rows
    .slice(headerRowIndex + 1)
    .filter((row) => !isEmptyRow(row))
    .map((row) =>
      headerKeys.reduce((result, key, columnIndex) => {
        const value = row[columnIndex]

        if (value !== null && value !== undefined) {
          result[key] = value
        }

        return result
      }, {})
    )
}

async function readCsvRows(file) {
  const papaParseModule = await import('papaparse')
  const Papa = papaParseModule.default || papaParseModule

  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      dynamicTyping: true,
      skipEmptyLines: false,
      complete: ({ data, errors }) => {
        if (errors.length > 0) {
          reject(new Error(errors[0].message))
          return
        }

        resolve(data)
      },
      error: reject
    })
  })
}

export async function readSpreadsheetRows(file) {
  const isCsv = file?.name?.toLowerCase().endsWith('.csv')

  if (isCsv) return readCsvRows(file)

  const { readSheet } = await import('read-excel-file/browser')
  return readSheet(file, { trim: false })
}

export async function readSpreadsheetObjects(file, options) {
  const rows = await readSpreadsheetRows(file)
  return spreadsheetRowsToObjects(rows, options)
}
